export default {
    // backend 

    'User with same username already exist!': 'User with same username already exist!',
    'User with same email already exist!': 'User with same email already exist!',
    'Wrong email or password!': 'Wrong email or password!',
    'Server error!': 'Server error!',
    'Email sending failed': 'Email sending failed',
    'expired': 'expired',
    'Mongodb has error': 'Mongodb has error',
    'Authentication token is invalid': 'Authentication token is invalid',
    'Invalid survey': 'Invalid survey',
    'User not found': 'User not found',
    'Email list not found': 'Email list not found',
    'Your account is not activated': 'Your account is not activated',
    'There is no survey': 'There is no survey',
    'File not upload': 'File not upload',
    'Old password is not correct': 'Old password is not correct',
    'Invalid smtp configuration': 'Invalid smtp configuration',

    // routes
    'Costumers': 'Costumers',
    'Costumer Payments': 'Costumer Payments',
    'Costumer Update': 'Costumer Update',
    'Costumer Update': 'Costumer Update',
    'Allotment Survey': 'Survey Templates',
    'Create Allot Survey': 'Create Allot Survey',
    'Response Plan': 'Response Plan',
    'Profile': 'Profile',
    'Register Page': 'Register Page',
    'Login Page': 'Login Page',
    'Activate success': 'Activate success',
    'Activate failed': 'Activate failed',
    'Payment Detail': 'Payment Detail',
    'Profile': 'Profile',
    'Create survey': 'Create survey',
    'View report': 'View report',
    'Edit survey': 'Edit survey',
    'Translate survey': 'Translate survey',
    'Add Question': 'Add Question',
    'Survey respondent': 'Survey respondent',
    'Survey passwords': 'Survey passwords',
    'Create Email': 'Create Email',
    'Edit Email': 'Edit Email',
    'Campaign Detail': 'Campaign Detail',
    'Purchase Responds': 'Purchase Responds',
    'Dashboard': 'Dashboard',
    'Survey': 'Survey',
    'Allotment Survey': 'Survey Templates',
    'Email list': 'Email list',
    'Campaign': 'Campaign',
    'Send survey': 'Send survey',
    'Create Survery Link': 'Create Survery Link',
    'Email setting': 'Email setting',
    'Help': 'Help',
    'Sync Email List': 'Sync Email List',
    'Dashboard': 'Dashboard',
    'Home': 'Home',
    'NO LIMITS': 'NO LIMITS',
    'Payment details': 'Payment details',
    'Update your info': 'Update your info',
    'SURVEY DETAILS': 'SURVEY DETAILS',
    'TOTAL SURVEYS': 'TOTAL SURVEYS',
    'ALLOTMENT SURVEYS': 'ALLOTMENT SURVEYS',
    'RESPONSE DETAILS': 'RESPONSE DETAILS',
    'TOTAL ALLOWED ANSWERS': 'TOTAL ALLOWED ANSWERS',
    'Survey': 'Survey',
    'Responses': 'Responses',
    'An Error occured with your payment': 'An Error occured with your payment',
    'RESPONSE PLANS': 'RESPONSE PLANS',
    'Package Name': 'Package Name',
    'No. of Responses': 'No. of Responses',
    'Price': 'Price',
    'Pay Now': 'Pay Now',
    'Close': 'Close',
    "Excellent": "Excellent",
    "Very Good": "Very Good",
    "Good": "Good",
    "Fair": "Fair",
    "Poor": "Poor",
    "Per-location QR codes": "Per-location QR codes",
    "Rooms / Tables / Locations": "Rooms / Tables / Locations",
    "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.": "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.",
    "Add range": "Add range",
    "Extra locations (comma-separated, e.g. T1, T2, VIP)": "Extra locations (comma-separated, e.g. T1, T2, VIP)",
    "QR per page": "QR per page",
    "Label prefix (Room / Table / Σημείο)": "Label prefix (Room / Table / Σημείο)",
    "Caption (e.g. SCAN TO ANSWER)": "Caption (e.g. SCAN TO ANSWER)",
    "Sheet title (defaults to survey name)": "Sheet title (defaults to survey name)",
    "Generate QR PDF": "Generate QR PDF",
    "locations": "locations",
    "Please choose a survey": "Please choose a survey",
    "No locations defined": "No locations defined",
    "Too many locations (max 1000)": "Too many locations (max 1000)",
    "Invalid range (from must be <= to)": "Invalid range (from must be <= to)",
    "PDF generated": "PDF generated",
    "QR Code Sheet": "QR Code Sheet",
    "Generated": "Generated",
    "Location": "Location",
    "Location (room / table):": "Location (room / table):",
    "Exact / list (e.g. 205, 210)": "Exact / list (e.g. 205, 210)",
    "Range from": "Range from",
    "Range to": "Range to",
    "Guest": "Guest",
    "Location — exact / list (e.g. 205, 210)": "Location — exact / list (e.g. 205, 210)",
    "Location range from": "Location range from",
    "Location range to": "Location range to",
    "is": "is",
    "is not": "is not",
    "includes": "includes",
    "does not include": "does not include",
    "between": "between",
    "contains": "contains",
    "does not contain": "does not contain",
    "on": "on",
    "before": "before",
    "after": "after",
    "value": "value",
    "min": "min",
    "max": "max",
    "If answer": "If answer",
    "go to": "go to",
    "Next question (default)": "Next question (default)",
    "Add rule": "Add rule",
    "Otherwise, go to": "Otherwise, go to",
    "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.": "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.",
    "Add this question's answer options first to build branching rules.": "Add this question's answer options first to build branching rules.",
    "Logic / Branching": "Logic / Branching",
    "optional": "optional",
    "End of survey": "End of survey",
    "A question with branching rules is answered before the survey continues.": "A question with branching rules is answered before the survey continues.",

    // reports — modern Analytical/Summary labels
    "Overall score": "Overall score",
    "Positive": "Positive",
    "positive": "positive",
    "No answers": "No answers",

    // reports — Summary period comparison
    "Period 1": "Period 1",
    "Period 2": "Period 2",
    "Compare periods": "Compare periods",
    "set Period 2": "set Period 2",

    // reports — Text reports search/sort
    "No respondents match": "No respondents match",
    "Search by location, name, email or answer text…": "Search by location, name, email or answer text…",
    "Sorted worst score first — the responses that need attention are at the top.": "Sorted worst score first — the responses that need attention are at the top.",

    // reports — Excel export
    "Excel export is not available for this report": "Excel export is not available for this report",
    "Choose a report type above to begin": "Choose a report type above to begin",
    "Filters": "Filters",
    "Hide filters": "Hide filters",
    "Show results": "Show results",
    "Print": "Print",
    "Answer:": "Answer:",
    "Choose a report type": "Choose a report type",
};